import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TopCarousel } from './components/TopCarousel';
import { Hook } from './components/Hook';
import { About } from './components/About';
import { Services } from './components/Services';
import { WhyUs } from './components/WhyUs';
import { Testimonials } from './components/Testimonials';
import { PromiseSection } from './components/Promise';
import { Urgency } from './components/Urgency';
import { CTA } from './components/CTA';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { WhatsAppFloat } from './components/WhatsAppFloat';
import { IntroCurtain } from './components/IntroCurtain';
import { LanguageProvider } from './LanguageContext';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-brand-ivory font-sans text-brand-charcoal selection:bg-brand-gold/30" data-id="element-1">
        <IntroCurtain data-id="element-2" />
        <Header data-id="element-3" />
        <main data-id="element-4">
          <Hero data-id="element-5" />
          <TopCarousel data-id="element-6" />
          <Hook data-id="element-7" />
          <About data-id="element-8" />
          <Services data-id="element-9" />
          <WhyUs data-id="element-10" />
          <Testimonials data-id="element-11" />
          <PromiseSection data-id="element-12" />
          <Urgency data-id="element-13" />
          <CTA data-id="element-14" />
          <FAQ data-id="element-15" />
        </main>
        <Footer data-id="element-16" />
        <WhatsAppFloat data-id="element-17" />
      </div>
    </LanguageProvider>;
}